import React from "react";

export default function Footer({ t, contact, logo }) {
  return (
    <footer className="bg-black text-white border-t-2 border-[#E11D2E]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={logo} alt="Raskt Hjem AS" className="h-12 w-auto bg-white p-1" />
              <div>
                <div className="font-display text-xl">RASKT HJEM AS</div>
                <div className="text-[10px] tracking-[0.22em] text-[#E11D2E]">STAVANGER · ROGALAND</div>
              </div>
            </div>
            <p className="mt-5 text-zinc-400 text-sm max-w-sm leading-relaxed">{t.footer.tagline}</p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.22em] text-zinc-400 mb-4">KONTAKT</div>
            <div className="space-y-2 text-sm">
              <a href={`tel:${contact.phone_tel}`} className="block hover:text-[#E11D2E]">{contact.phone_display}</a>
              <a href={`mailto:${contact.email}`} className="block hover:text-[#E11D2E] break-all">{contact.email}</a>
              <div className="text-zinc-400">{contact.owner}</div>
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.22em] text-zinc-400 mb-4">NAVIGASJON</div>
            <div className="grid grid-cols-2 gap-2 text-sm">
              <a href="#services" className="hover:text-[#E11D2E]">{t.nav.services}</a>
              <a href="#why" className="hover:text-[#E11D2E]">{t.nav.why}</a>
              <a href="#coverage" className="hover:text-[#E11D2E]">{t.nav.coverage}</a>
              <a href="#reviews" className="hover:text-[#E11D2E]">{t.nav.reviews}</a>
              <a href="#faq" className="hover:text-[#E11D2E]">{t.nav.faq}</a>
              <a href="#quote" className="hover:text-[#E11D2E]">{t.nav.quote}</a>
            </div>
          </div>
        </div>

        <div className="mt-14 border-t border-zinc-800 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-xs text-zinc-500">
            © {new Date().getFullYear()} {contact.company}. {t.footer.rights}
          </div>
          <div className="font-display text-[18vw] md:text-[8vw] leading-none text-white/5 select-none pointer-events-none absolute right-0 bottom-0 hidden md:block">
            RASKT HJEM
          </div>
        </div>
      </div>
    </footer>
  );
}
